var util = (function() {

  /**
   * This function is used to return the name of the owner associated with a provided owner ndx
   * The function takes four arguments
   *  + the data to evaluate
   *  + the ndx to filter on
   *  + the name of the ndx field
   *  + the name of the displayField
   * @param  {array} data [the data to evaluate]
   * @param  {string/number} val  [the ndx to filter on]
   * @param {string}      [he name of the ndx field]
   * @param {string}      [the name of the displayField]
   */
  function returnDisplayName(data, val, valueField, displayField) {
    if ( !data ) throw Error('Please provide data to evaluate.');
    if ( !val ) throw Error('Please provide a value to seach for.');
    if ( !valueField ) throw Error('Please provide the name of the value field.');
    if ( !displayField ) throw Error('Please provide the name of the displayField.');

    var name = data
      .filter(function(d) {
        return d[valueField] === val;
      })
      .map(function(d) {
        return d[displayField];
      })[0];
    return name;
  }

  /**
   * This function is used to filter data associated with a given value
   * The function takes an array of objects and filters the data by a specified property and value
   *
   * Example: We want to filter an array of objects to return a list of location ndxs associated with one owner
   * To accomplish this we would run getAssociatedData(data, "2", "own_ndx", "loc_ndx")
   *
   * @param  {array} data       [array of objects to be filtered]
   * @param  {number/string/boolen} assocValue [the property value to filter on]
   * @param  {string} field1     [The name of the property to filter on]
   * @return {array}            [An array containing an array of data filtered for the specified value ]
   */
  function getAssociatedData(data, assocValue, field1) {
    if ( !data ) throw Error('Please provide data to evaluate.');
    if ( !data ) throw Error('Please provide an assoc value to evaluate.');
    if ( !data ) throw Error('Please provided the name of the assoc value field to evaluate.');
    if ( !data ) throw Error('Please provide the name of the field to return asosciated data for.');

    return data
      .filter(function(d) {
        return d[field1] === assocValue;
      })
  }

  /**
   * This function is used to filter and map data associated with a given value
   * The function takes an array of objects and filters the data by a specified property and value
   * The function then maps the data, returning an array of values for a specified property
   *
   * Example: We want to filter an array of objects to return a list of location ndxs associated with one owner
   * To accomplish this we would run getAssociatedData(data, "2", "own_ndx", "loc_ndx")
   *
   * @param  {array} data       [array of objects to be filtered]
   * @param  {number/string/boolen} assocValue [the property value to filter on]
   * @param  {string} field1     [The name of the property to filter on]
   * @param  {string} field2     [The name of the property to return values for]
   * @return {array}            [An array containing an array of values for a specified property, filtered for the specified value ]
   */
  function mapAssociatedData(data, assocValue, field1, field2) {
    if ( !data ) throw Error('Please provide data to evaluate.');
    if ( !data ) throw Error('Please provide an assoc value to evaluate.');
    if ( !data ) throw Error('Please provided the name of the assoc value field to evaluate.');
    if ( !data ) throw Error('Please provide the name of the field to return asosciated data for.');

    return data
      .filter(function(d) {
        return d[field1] === assocValue;
      })
      .map(function(d) {
        return d[field2];
      });
  }

  function getDoubleAssociatedData(primaryData, secondaryData, assocField) {
    if ( !primaryData ) throw Error('Please provide primary data to evaluate.');
    if ( !secondaryData ) throw Error('Please provide secondary data to evaluate.');
    if ( !assocField ) throw Error('Please provide an assoc field to evaluate.');

    return primaryData
      .filter(function(d) {
        return secondaryData.includes(d[assocField]);
      })
      .map(function(d) {
        return d;
      });
  }

  function getTripleAssociatedData(primaryData, secondaryData, assocField1, assocField2, assocField3, val) {
    return primaryData
      .filter(function(d) {
        return secondaryData.includes(d[assocField1]) && d[assocField2] === val;
      })
      .map(function(d) {
        return d[assocField3];
      })
  }

  function getValuesByField(data, field) {
    let arr = data.map(function(d) {
      return d[field];
    });
    return arr;
  }

  function setActiveChips(chipBag, data) {
    chipBag.chips.forEach(function(v,k) {
      if ( data.includes(v.chipValue) ) {
        v.toggleState(true);
      } else {
        v.toggleState(false);
      }
    });
  }

  function updateArray(arr, val) {
    if ( !arr ) throw Error('Please provide an array to evaluate' );
    if ( !val ) throw Error('Please provide a value to add or remove from array' );

    let arrCopy = arr.slice(0, arr.length);
    var index = arrCopy.indexOf(val);
    if (index > -1) {
      arrCopy.splice(index, 1);
    } else {
      arrCopy.push(val);
    }
    return arrCopy;
  }

  function updateObjectArray(arr, obj, property) {
    if ( !arr ) throw Error('Please provide an array to evaluate' );
    if ( !obj ) throw Error('Please provide an object to add or remove from array' );
    if ( !property ) throw Error('Please provide the property used to determine if the object already exists in the array' );

    let propertyMap = arr.map(function(d) {
      return d[property];
    });

    var index = propertyMap.indexOf(obj[property]);
    if ( index > -1) {
      arr.splice(index, 1);
    } else {
      arr.push(obj);
    }
    return arr;
  }

  function addZeroToDate(val) {
    let integerDate = parseInt(val);
    let stringDate = val.toString();
    if ( integerDate < 10 ) {
      stringDate = '0' + stringDate;
      return stringDate;
    } else {
      return val;
    }
  }

  function formatDate(date, format) {
    var newDate = new Date(date);
    if ( format.toLowerCase() === 'mm/dd/yyyy' ) {
      return addZeroToDate(newDate.getMonth()+1) + '/' + addZeroToDate(newDate.getDate()) + '/' + newDate.getFullYear();
    } else if ( format.toLowerCase() === 'yyyy-mm-dd' ) {
      return newDate.getFullYear() + '-' + addZeroToDate(newDate.getMonth()+1) + '-' + addZeroToDate(newDate.getDate());
    }
  } // formatDate

  /**
   * This function is used to create a request object for a jQuery ajax request
   * @param  {string} table  [table name]
   * @param  {string} fields [fields]
   * @param  {string} sort   [field(s) to sort by i.e. location_ndx ASC]
   * @param  {string/number} drupalUserid   [drupal userid to parse table by]
   * @param  {boolean} drupalUserSwitch   [whether the table shoudl be filtered by userid]
   * @return {object}        [jQuery ajax request object]
   */
  function createRequest(table, fields, sort, drupalUserid, drupalUserSwitch) {
    return {
        url: "/sites/all/themes/lrebootstrap/src/php/view/",
        table: table,
        fields: [fields],
        sort: sort || '',
        drupal_userid: drupalUserid || 1,
        drupal_user_switch: typeof drupalUserSwitch === 'undefined' ? false : drupalUserSwitch
    }
  }

  const isDefined = (prop) => {
    if ( typeof prop === "undefined" ) {
      return false;
    } else {
      return true;
    }
  }

  const setNullText = prop => {
    if ( prop === null || prop === "" ) {
      return "none";
    }
    return prop;
  }

  // Return utility methods
  return {
    returnDisplayName: returnDisplayName,
    getAssociatedData: getAssociatedData,
    mapAssociatedData: mapAssociatedData,
    getDoubleAssociatedData: getDoubleAssociatedData,
    getTripleAssociatedData: getTripleAssociatedData,
    getValuesByField: getValuesByField,
    setActiveChips: setActiveChips,
    updateArray: updateArray,
    updateObjectArray: updateObjectArray,
    addZeroToDate: addZeroToDate,
    formatDate: formatDate,
    createRequest: createRequest,
    isDefined: isDefined,
    setNullText: setNullText
  }
})();
